var GL_FRAGMENT_SHADER = 0x8b30;
var GL_VERTEX_SHADER = 0x8b31;
export default function getShaderTypeName(type) {
  switch (type) {
    case GL_FRAGMENT_SHADER:
      return 'fragment';

    case GL_VERTEX_SHADER:
      return 'vertex';

    default:
      return 'unknown type';
  }
}
//# sourceMappingURL=get-shader-type-name.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/webgl/dist/esm/glsl-utils/get-shader-type-name.js
// module id = 645
// module chunks = 0